export default "__VITE_PUBLIC_ASSET__9fd215d3__"